module.exports = "/_next/static/images/Hero-xs@3x-0d1652174b6ded4e25a279980ea9cd9d.webp";